import React from 'react';
import WName from '../WName';
import QL from './QuestionLink';
import PL from '../problems/ProblemLink';
import AL from '../angles/AngleLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, Qual, Fibonacci} from '../common';

// ‘’ –

// What's wrong with TBH?
export const tbh = {
  name: "tbh",
  prelude: <span>What if I just want to <i><PL name="form.feel">reassure</PL></i> an ‘<QL>other</QL>’?</span>,
  question: <span>What’s <i>wrong</i> with ‘TBH’?</span>,
  answerPreview: <div className="answer-preview">
    <p>‘TBH’ (meaning ‘to be honest’ rides on the implicit assumption that the ‘norm’ is <i>dishonesty</i>. So <i>that</i> is the problem.</p>
  </div>,
  answer: <div className="answer">
    <p>It has to do with the <PL>human standard</PL> ‘sneaking’ a bunch of <AL name="fields.logic">illogical</AL> <i>assumptions</i> (via <NW>explainage</NW>) into ‘discourse’.</p>
    <p>Bottom-line assumptions ‘snuck’ into the word ‘discourse’, for example, include:</p>
    <ul>
      <li>‘You’ and ‘I’ are separate ‘actors’.</li>
      <li><i>Competing</i>, as in a <i><LRL>game</LRL></i>.</li>
      <li>Each <AL name="you">Piece™</AL> alone.</li>
      <li>All alone.</li>
      <li><AL name="together">Die alone</AL>.</li>
      <li><Fibonacci capFirst delimiter=", " reps={[5, 7]}>etc.</Fibonacci></li>
    </ul>
    <p>For, you know, <i>example</i>. Having to say ‘TBH’ implies that <i>this website is not questioning all of that</i>.</p>
    <p>Maybe.</p>
  </div>,
};
